import { gql } from "src/__generated__";

export const GET_COMMUNITY_JOB_OPPORTUNITIES = gql(`
  query GetCommunityJobOpportunitiesForPro {
		getCommunityJobOpportunitiesForPro {
			id
			title
			description
			location {
				country
				state
				area
			}
			salary {
				starting
				cap
				currency
        currencyCode
			}
			employmentType
			duration {
				value
				type
			}
			tags {
				name
			}
			organization {
				name
			}
      hasApplied
      canApply
			applicationDeadline
			createdAt
		}
	}
`);

export const GET_COMMUNITY_ANNOUNCEMENTS = gql(`
  query GetCommunityAnnouncementsForPro {
		getCommunityAnnouncementsForPro {
			id
			title
			content
			type
			jobOpportunity {
				id
				title
			}
			organization {
				name
			}
			publishedAt
		}
	}
`);

export const MY_COMMUNITY_JOB_APPLICATIONS = gql(`
  query MyCommunityJobApplications($limit: Float) {
    myCommunityJobApplications(limit: $limit) {
      id
      jobOpportunity {
        id
        title
      }
      education {
        id
        schoolName
        fieldOfStudy
        qualification
        createdAt
      }
      employmentHistory {
        id
        companyName
        jobTitle
        description
        startedAt
        endedAt
        media {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
        createdAt
      }
      projectHistory {
        id
        name
        description
        startedAt
        endedAt
        media {
          key
          mimeType
          originalUrl
          thumbnailUrl
        }
        videos
        createdAt
      }
      certifications {
        id
        name
        issuerCertificationId
        issuedBy
        issuedAt
        url
        createdAt
      }
      createdAt
    }
  }
`);

export const GET_COMMUNITY_JOB_OPPORTUNITY = gql(`
  query GetCommunityJobOpportunityForApplication($id: String!) {
    getCommunityJobOpportunityForPro(jobOpportunityId: $id) {
      id
      title
      description
      employmentType
      organization {
        name
      }
      location {
        area
        state
        country
      }
      salary {
        starting
        cap
        currency
        currencyCode
      }
      duration {
        value
        type
      }
      tags {
        id
        name
      }
      hasApplied
      canApply
      createdAt
      applicationDeadline
    }
  }
`);

export const CREATE_COMMUNITY_JOB_APPLICATION = gql(`
  mutation CreateCommunityJobApplication($input: CreateCommunityJobApplicationDto!) {
    createCommunityJobApplication(input: $input) {
      id
      status
      createdAt
    }
  }
`);

export const GET_COMMUNITY_ANNOUNCEMENT = gql(`
  query GetCommunityAnnouncementForPro($announcementId: String!) {
    getCommunityAnnouncementForPro(announcementId: $announcementId) {
      id
      title
      content
      type
      jobOpportunity {
        id
        title
      }
      organization {
        name
      }
      publishedAt
    }
  }
`);